//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import angular from 'angular';

import template from '@legacy-components/common/universal-image-actions/showroom-settings-customize-products.html';

import { debounce } from '@utils/debounce';

export class ShowroomSettingsCustomizeProducts {
  public STATES;
  public filterState;
  public filtersCollapsed: boolean;
  public trackingCategory: string;
  public trackingAction: string;
  public trackingLabels;
  public onFiltersChanged = debounce((filterType, filterInfo) => {
    this.updateFilters();
    this.recordFiltersChangedEvents(filterType, filterInfo);
  }, 200);

  // Bound fields
  public startingFilterState;
  public itemId: string;
  public onUpdateCuratedProductsState;
  public onFiltersUpdated;

  constructor(
    private ShowroomApiService,
    private ShowroomService,
    private TrackingService,
    private SHOWROOM_CURATION_STATES,
  ) {}

  public recordFiltersChangedEvents = (filterType, filterState) => {
    this.TrackingService.recordEvent(
      this.trackingCategory,
      this.trackingAction,
      this.trackingLabels.filterUpdated(filterType, filterState),
    );
  };

  public updateFilters = () => {
    this.onFiltersUpdated(this.filterState);
  };

  public updateCuratedProductsState = (newValue) => {
    this.TrackingService.recordEvent(
      this.trackingCategory,
      this.trackingAction,
      this.trackingLabels.productRecsUpdated(newValue),
    );
    this.onUpdateCuratedProductsState(newValue);
  };

  public $onInit() {
    this.STATES = this.SHOWROOM_CURATION_STATES;
    this.filtersCollapsed = true;
    this.trackingCategory = this.ShowroomService.getTrackingCategory();
    this.trackingAction = this.ShowroomService.getTrackingAction();
    this.trackingLabels = {
      helpLinkClicked: (linkName) => `HelpLinkClicked=${linkName}`,
      productRecsUpdated: (recState) => `SetProductRecs=${recState}`,
      filterUpdated: (filterType, filterState) => {
        return filterState.isSelected
          ? `FilterSelected=${filterType}`
          : `FilterUnselected=${filterType}`;
      },
    };

    this.filterState = angular.copy(this.startingFilterState);
  }
}

angular.module('uia').component('showroomSettingsCustomizeProducts', {
  bindings: {
    allProductsCrawled: '<',
    hasProductCatalog: '<',
    itemId: '<',
    startingFilterState: '<',
    onFiltersUpdated: '<',
    startingProductList: '<',
    onProductsUpdated: '<',
    useCuratedRecommendations: '<',
    onUpdateCuratedProductsState: '<',
    curatedProductsState: '<',
  },
  template,
  controller: [
    'ShowroomApiService',
    'ShowroomService',
    'TrackingService',
    'SHOWROOM_CURATION_STATES',
    ShowroomSettingsCustomizeProducts,
  ],
});
